import React from 'react';
import { useNavigate } from 'react-router-dom';
import { planetFitnessMachines } from '../data/workoutPlans';
import './Exercises.css';

function Exercises() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="exercises-screen">
        <div className="exercises-header">
          <button className="back-button" onClick={() => navigate('/')}>← Back</button>
          <h2>Exercise Library</h2>
        </div>

        <h3 className="section-title">🏋️ Planet Fitness Machines</h3>
        
        {Object.entries(planetFitnessMachines).map(([key, machine]) => (
          <div key={key} className="machine-card">
            <h4>{machine.name}</h4>
            <p><strong>How to Find:</strong> {machine.howToFind}</p>
            <p><strong>Setup:</strong> {machine.setup}</p>
          </div>
        ))}

        <h3 className="section-title">💪 Bodyweight Exercises</h3>
        
        {['Pull-ups', 'Push-ups', 'Pike Push-ups', 'Tricep Dips', 'Glute Bridges', 'Bulgarian Split Squats'].map((ex) => (
          <div key={ex} className="exercise-card-simple">
            <h4>{ex}</h4>
            <p>See workout screen for detailed instructions</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Exercises;
